import { render, staticRenderFns } from "./postit-on-image.vue?vue&type=template&id=7b37267e&scoped=true"
import script from "./postit-on-image.vue?vue&type=script&lang=js"
export * from "./postit-on-image.vue?vue&type=script&lang=js"
import style0 from "./postit-on-image.vue?vue&type=style&index=0&id=7b37267e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b37267e",
  null
  
)

export default component.exports